import * as Yup from 'yup';
import {yupStringMin} from '../../../../functions/validationsYup';

export const getPricingValidationSchema = (globalT: (key: string, options?: Record<string, unknown>) => string) => {
    return Yup.object().shape({
        title: yupStringMin().required(globalT('errorRequired')),
        price: Yup.number().required(globalT('errorRequired')).positive(globalT('errorNumber')),
        ticketsAmount: Yup.number()
            .required(globalT('errorRequired'))
            .min(1, globalT('errorMinValue', {min: 1}))
            .max(10, globalT('errorMaxValue', {max: 10}))
    });
};

